import { useQuery } from '@tanstack/react-query';
import instance from '@src/api/axiosInstance';

interface RecommendedAnalysis {
  id: number;
  query: string;
  deep_mode: boolean;
}

const getRecommendedAnalyses = async (): Promise<RecommendedAnalysis[]> => {
  const response = await instance.get('/nexa/analysis-templates/recommended');
  return response.data;
};

const useGetRecommendedAnalyses = () => {
  return useQuery({
    queryKey: ['recommended-analyses'],
    queryFn: getRecommendedAnalyses,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export default useGetRecommendedAnalyses;
